module.exports = __webpack_public_path__ + "img/logo_page_gree.9a5aed9a.png";